<template>
  <div class="container">
    <h1 class="header">Therian Meetup planner</h1>
    <facebook-login class="header"
      :appId="appId.toString()"
      @login="onLogin"
      @logout="onLogout"
      @sdk-loaded="sdkLoaded">
    </facebook-login>
    <img v-if="!isConnected"
      :src="loginImage"
      class="header login">
    <authenticated v-if="isConnected && fbloaded" :fbdata="fbdata">
    </authenticated>
  </div>
</template>

<script>
import facebookLogin from 'facebook-login-vuejs';
import authenticated from '@/components/Authenticated';
import loginImage from '../assets/login.svg';

export default {
  name: 'app',
  data() {
    return {
      appId: process.env.APP_ID,
      loginImage,
      isConnected: false,
      fbloaded: false,
      fbdata: {
        name: '',
        email: '',
        personalID: '',
      },
      FB: undefined,
    };
  },
  components: { facebookLogin, authenticated },
  methods: {
    getUserData() {
      this.FB.api('/me', 'GET', { fields: 'id,name,email' },
        (userInformation) => {
          this.fbdata.personalID = userInformation.id;
          this.fbdata.email = userInformation.email;
          this.fbdata.name = userInformation.name;
          console.log('set', userInformation, this.fbdata);
          this.fbloaded = true;
        },
      );
    },
    sdkLoaded(payload) {
      console.log('sdkLoaded');
      this.isConnected = payload.isConnected;
      this.FB = payload.FB;
      if (this.isConnected) this.getUserData();
    },
    onLogin(e) {
      console.log('onLogin', e);
      if (e.response.authResponse) {
        this.isConnected = true;
        this.getUserData();
      }
    },
    onLogout() {
      console.log('onLogout');
      this.isConnected = false;
    },
  },
};
</script>

<style>
  #app {
    display: flex;
    flex-direction: column;
    align-items: flex-start
  }

  .login {
    width: 200px;
    margin: auto;
  }

  @media (min-width: 769px){
    .header {
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue